import React, { useState } from 'react'
import PropTypes from 'prop-types'
import FormSuccess from './FormSuccess'
import VerifyAddressForm from '../forms/VerifyAddressForm'

const VerifyAddress = (props) => {
    const STATUS_PENDING = 'P'
    const STATUS_APPROVED = 'A'

    const [allowChange, setAllowChange] = useState(false)
    const [expandForm, setExpandForm] = useState(false)

    const handleChangeAddress = event => {
        event.preventDefault()
        setAllowChange(true)
    }

    const AddressApproved = (
        <div className='alert-success'>
            <FormSuccess
                message={
                    <span>Your address <span className='bold'>{props.serviceAddress}</span> is verified. <a href='#' onClick={handleChangeAddress} className='color-indigo underline'>Change address</a>.</span>
                } icon={false}
            />
        </div>
    )

    const AddressForm = (
        <div>
            <div className='form-warning mb-3 text-center'>We require you to verify your address so emergency services can assist you in a crisis.<br />Please begin by entering your address below:</div>
            <VerifyAddressForm
                serviceId={props.serviceId}
                expandForm={expandForm}
                setExpandForm={setExpandForm}
                handleSuccess={props.handleSuccess}
            />
        </div>
    )

    const AddressPending = (
        <div className='form-warning'>
            <div>You don't need to do anything. Your address verification for <span className='bold'>{props.serviceAddress}</span> will be completed shortly.</div>
        </div>
    )

    if (!allowChange && props.ipndStatus === STATUS_APPROVED) {
        return AddressApproved
    } else if (!allowChange && props.ipndStatus === STATUS_PENDING) {
        return AddressPending
    } else {
        return AddressForm
    }
}

VerifyAddress.propTypes = {
    serviceId: PropTypes.number.isRequired,
    ipndStatus: PropTypes.string,
    serviceAddress: PropTypes.string,
    handleSuccess: PropTypes.func.isRequired
}

export default VerifyAddress



// WEBPACK FOOTER //
// ./resources/js/components/VerifyAddress.js